import React from "react";
import { Select, TextField } from "@vitalsource/vstui";
import { t } from "../../../core/translate";

export default () => (
  <div>
    <Select
      id="security-question-input"
      name="user[question_id]"
      data-key="questionId"
      defaultValue={"6"}
      fullWidth
      required
      label={t("registration.security-question", "Security Question")}
    >
      <option value={6}>
        {t("registration.security-question6", "Security Question 6")}
      </option>
      <option value={7}>
        {t("registration.security-question7", "Security Question 7")}
      </option>
      <option value={8}>
        {t("registration.security-question8", "Security Question 8")}
      </option>
      <option value={9}>
        {t("registration.security-question9", "Security Question 9")}
      </option>
      <option value={10}>
        {t("registration.security-question10", "Security Question 10")}
      </option>
    </Select>
    <TextField
      required
      fullWidth
      id="security-answer-input"
      type="text"
      data-key="questionResponse"
      name="user[question_response]"
      label={t("registration.security-answer", "Security Answer")}
    />
  </div>
);
